
import Spinner from "../../Utils/Spinner";

const MapPanelSpinner = () => {
  return (
    <div className="map-sidebar-loading-spinner">
      <Spinner />
    </div>
  );
};

export default MapPanelSpinner;
